export class FindOneScopePatternNumberRequest {
    makeName?: string;
    docNumber?:string;
}